<script setup>
import {ref} from "vue";
import {useDataTable} from "../../utils/datatableHelper.js";
import DocumentTemplateService from "../../services/DocumentTemplateService.js";
import Button from "../../components/forms/Button.vue";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import CreateEditDocumentTemplateModal from "../../components/modals/CreateEditDocumentTemplateModal.vue";
import {useToast} from "vue-toastification";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

const toast = useToast();

const isLoading = ref(false);
// nastavení tabulky (stránka, počet řádků, řazení, filtry) se pamatuje v localStorage pod klíčem DOCUMENT-TEMPLATES-INDEX
const datatableRef = ref(null);
const datatable = useDataTable(fetchDocumentTemplates, 'fullname', 10, true, {}, 'DOCUMENT-TEMPLATES-INDEX', datatableRef);
const rows = ref([]);
const columns = ref([
  {label: t('documentTemplatesIndex.name'), field: 'name', filterOptions: {enabled: true, skipDiacritics: true, placeholder: 'Filtrovat podle názvu'}},
  {label: t('documentTemplatesIndex.description'), field: 'description', filterOptions: {enabled: true, skipDiacritics: true, placeholder: 'Filtrovat podle popisu'}},
  {label: t('documentTemplatesIndex.generated2'), field: 'generated_count', filterOptions: {enabled: false, skipDiacritics: true, placeholder: 'Filtrovat podle počtu vygenerovaných'}},
  {label: t('documentTemplatesIndex.to_be_signed2'), field: 'to_be_signed_count', filterOptions: {enabled: false, skipDiacritics: true, placeholder: 'Filtrovat podle počtu k podepsání'}},
  {label: t('documentTemplatesIndex.signed2'), field: 'signed_count', filterOptions: {enabled: false, skipDiacritics: true, placeholder: 'Filtrovat podle počtu podepsaných'}},
  {
    label: t('documentTemplatesIndex.active'), field: 'is_active', formatFn: (value) => {
      return yesNoMap.filter((type) => type.value === value)[0].label
    }, filterOptions: {enabled: true, skipDiacritics: true, placeholder: t('documentTemplatesIndex.filter_by_activity')}
  },
  {label: '', field: 'action', sortable: false, html: true},
]);

const yesNoMap = [
  {label: t('documentTemplatesIndex.yes'), value: true},
  {label: t('documentTemplatesIndex.no'), value: false},
];

function fetchDocumentTemplates(body) {
  DocumentTemplateService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    rows.value = response.data;
  });
}

function createDocumentTemplate() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateEditDocumentTemplateModal, {documentTemplate: null});
  reveal();
  onConfirm((data) => {
    DocumentTemplateService.saveDocumentTemplate(data, null).then(response => {
      toast.success(response.message);
      fetchDocumentTemplates(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading d-flex justify-content-between align-items-center">
      <div class="page-section__title">
        {{ t('documentTemplatesIndex.document_templates') }}
      </div>
      <div class="flex justify-end">
        <Button :label="t('documentTemplatesIndex.add_template')" icon="mdi-text-box-plus" @click="createDocumentTemplate()"></Button>
      </div>
    </div>

    <div class="page-section__content">
      <div class="mt-3">
        <vue-good-table
            ref="datatableRef"
            :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
            :columns="columns"
            :rows="rows"
            mode="remote"
            @page-change="datatable.onPageChange"
            @sort-change="datatable.onSortChange"
            @column-filter="datatable.onColumnFilter"
            @per-page-change="datatable.onPerPageChange"
            :totalRows="datatable.totalRecords.value"
            :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('documentTemplatesIndex.entriesPerPage'),
                  nextLabel: t('documentTemplatesIndex.next'),
                  prevLabel: t('documentTemplatesIndex.previous'),
                  ofLabel: 'z',
                }">
          <template #table-row="props">
          <span v-if="props.column.field === 'action'">
            <span style="font-weight: bold; float: right">
                <router-link :to="{ name: 'DocumentTemplateDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-primary"><i class="mdi mdi-eye"/></button></router-link>
            </span>
          </span>
          </template>
          <template v-slot:emptystate v-if="!isLoading">
            <div class="text-center">
              {{ t('documentTemplatesIndex.no_records_found') }}
            </div>
          </template>
          <template v-slot:emptystate v-if="isLoading">
            <div class="text-center">
              {{ t('documentTemplatesIndex.data_loading') }}
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
